import type { Copy } from "../types";

export const tr: Copy = {
    seo: {
      title: "Araç Yaş Hesaplayıcı | Yıl ve Ay ile araç yaşı kontrolü",
      description:
        "Bir aracın üretim yılı ve isteğe bağlı ay bilgisinden tam yaşını kontrol edin. Yıl, ay, gün, toplam gün ve kilometre taşı zamanlamasını tek bir temiz araçta görün.",
      keywords: [
        "araç yaş hesaplayıcı",
        "araç yaşı",
        "araba yaşı hesaplama",
        "üretim yılıyla araç yaşı",
        "üretim ayıyla araç yaşı",
        "arabam kaç yaşında",
        "araç yaşı kontrolü",
        "RC yaş hesaplayıcı",
        "araç tarih hesaplayıcı",
        "aylı araç yaş hesaplayıcı",
        "mParivahan alternatifi",
        "Parivahan alternatifi",
        "RTO araç yaş hesaplayıcı",
        "araç kayıt yaşı kontrolü",
        "araç tescil yaşı",
      ],
      faq: [
        {
          question: "Bu hesaplayıcı ne yapar?",
          answer:
            "Seçilen üretim yılı ve isteğe bağlı ay bilgisine göre bir aracın tam yaşını hesaplar, ardından yıl, ay, gün ve kilometre taşı bilgilerini gösterir.",
        },
        {
          question: "Neden isteğe bağlı ay var?",
          answer:
            "Ay seçimi yaş hesabını daha hassas hale getirir. Ayı atladıysanız uygulama seçilen yılın Ocak ayını kullanır.",
        },
        {
          question: "Gelecek bir yıl veya ay seçebilir miyim?",
          answer:
            "Hayır. Gelecek yıllar engellenir ve seçilen yıl mevcut yıl ise gelecek aylar devre dışı bırakılır.",
        },
      ],
    },
    headerTagline: "Araç yardımcı aracı",
    headerTitle: "Araç Yaş Hesaplayıcı",
    reset: "Sıfırla",
    switchToLight: "Açık moda geç",
    switchToDark: "Koyu moda geç",
    languageLabel: "Dil",
    languageEnglish: "İngilizce",
    languageHindi: "Hintçe",
    heroEyebrow: "Araç yaşı, net",
    heroTitle: "Araç yaşı için sade bir tarih aracı.",
    heroDescription: "Üretim yılını seçin. Daha hassas sonuç için isterseniz ay ekleyin.",
    yearSelectLabel: "Üretim yılı",
    monthSelectLabel: "Üretim ayı",
    includeMonthLabel: "Daha fazla hassasiyet için belirli ayı ekle",
    includeMonthNote: "Ay eklemezseniz hesaplama için Ocak kullanılır.",
    yearOnlyBadge: "Sadece yıl",
    yearMonthBadge: "Yıl + ay",
    yearPlaceholder: "Yıl seçin",
    monthPlaceholder: "Ay seçin",
    inputTitle: "Üretim yılı",
    inputLabel: "Üretim yılı",
    blockedDateNote: "Gelecek yıllar engellidir.",
    result: "Sonuç",
    vehicleAgeLead: "Aracınız",
    asOfToday: "Bugün itibarıyla",
    years: "Yıl",
    months: "Ay",
    days: "Gün",
    totalDays: (count) => `${count.toLocaleString("en-IN")} toplam gün`,
    ageLabels: { almostNew: "Yeni gibi", modern: "Modern", mature: "Olgun", classic: "Klasik" },
    estimatedValue: {
      high: "Yüksek ikinci el potansiyeli",
      healthy: "İyi değer koruması",
      moderate: "Orta düzey değer kaybı",
      collector: "Koleksiyon ilgisi artabilir",
    },
    maintenanceTitle: "Bakım",
    maintenance: {
      routine: "Düzenli servis ve OEM bakımı",
      watch: "Frenleri, sıvıları ve lastikleri izleyin",
      plan: "Aşınan parçalar ve kontroller için plan yapın",
      specialized: "Uzman bakım daha önemli hale gelir",
    },
    registrationTitle: "Tescil",
    registration: {
      collector: "Bazı bölgelerde koleksiyon aracı uygulamasına girebilir",
      classic: "Bazı bölgelerde klasik araç tescili uygulanabilir",
      standard: "Standart yenileme ve bölgesel kontroller bekleyin",
      regular: "Genellikle normal tescil geçerlidir",
    },
    upcomingMilestoneTitle: "Yaklaşan kilometre taşı",
    milestoneTimelineTitle: "Kilometre taşı zaman çizelgesi",
    milestoneRemaining: ({ label, days }) => `${label} için ${days.toLocaleString("tr-TR")} gün kaldı`,
    reached: "Ulaşıldı",
    upcoming: "Yaklaşan",
    allMilestonesReachedTitle: "Listelenen tüm kilometre taşlarına ulaşıldı",
    allMilestonesReachedBody: "Bu araç, uygulamada gösterilen kilometre taşı aralığını geçti.",
    copySummary: "Özeti kopyala",
    shareResult: "Sonucu paylaş",
    resetMessage: "Hesaplayıcı sıfırlandı",
    summaryCopied: "Özet panoya kopyalandı",
    clipboardFailed: "Panoya erişim başarısız",
    emptyTitle: "Tam dökümü görmek için üretim yılını seçin",
    emptyDescription:
      "Bir yıl seçildiğinde tam yaş, toplam gün, bakım notları, klasik durumu ve kilometre taşı zamanlaması görünür.",
    shareTitle: "Araç Yaş Hesaplayıcı",
    summary: ({ label, years, months, days, asOf }) =>
      `Aracım ${label} tarihinde üretildi ve ${asOf} itibarıyla ${years} yıl, ${months} ay ve ${days} gün yaşında.`,
    milestones: {
      1: { label: "İlk yıl", note: "Garanti ve servis planlaması için kullanışlıdır." },
      3: { label: "Üç yıl", note: "İkinci el ve değer değişimi için yaygın bir dönüm noktasıdır." },
      5: { label: "Beş yıl", note: "Daha derin bakım bütçesi için iyi bir zamandır." },
      10: { label: "On yıl", note: "Yaşlanan parçalar daha fazla dikkat ister." },
      15: { label: "On beş yıl", note: "Birçok bölgede klasik araç yaklaşımı burada başlar." },
      25: { label: "Yirmi beş yıl", note: "Bazı pazarlarda koleksiyon ve ithalat için çekici olabilir." },
    },
  };
